import Head from 'next/head';
import {GSSKT_HOST} from '../../../config/constants/hosts';
import {OGP_IMAGE_PATH_BOX} from '../../../core/entities/box/constants';
import {GeneralFooter} from '../../../shared/components/Footer/general';
import {GeneralHeaderContainer} from '../../../shared/components/Header/General/container';
import {useIsAppWebView} from '../../../shared/hooks/useIsAppWebView';
export default function Layout({children}: React.PropsWithChildren) {
  const isWebView = useIsAppWebView();
  return (
    <>
      <Head>
        <title key="title">外資就活相談室</title>
        <meta key="og:title" property="og:title" content="外資就活相談室" />
        <meta
          key="description"
          name="description"
          content="就活に関する質問を受け付けています"
        />
        <meta
          key="og:description"
          property="og:description"
          content="就活に関する質問を受け付けています"
        />
        <meta
          key="keywords"
          property="keywords"
          content="外資,就活,外資系,就職,投資銀行,コンサル,商社"
        />
        <meta
          key="og:image"
          property="og:image"
          content={`${GSSKT_HOST}${OGP_IMAGE_PATH_BOX}`}
        />
      </Head>
      <div className="pb-[74px]">
        {!isWebView && <GeneralHeaderContainer />}
        <main>{children}</main>
        {!isWebView && <GeneralFooter />}
      </div>
    </>
  );
}
